import styled, { css } from 'styled-components';
import TextEllipsis from '../style/TextEllipsis.js';
import { headerHeight, color, textColor } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';

export const StyledModal = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding-top: calc(${headerHeight}px + var(--space-to-pinned-notification));
  overflow-y: auto;
  background-color: ${color.black};
`;

export const Header = styled.div`
  position: fixed;
  top: var(--space-to-pinned-notification);
  left: 0px;
  right: 0px;
  border-bottom: 1px solid rgba(100, 100, 100, 0.25);
  padding: 0px 16px;
  height: ${headerHeight}px;
  display: flex;
  align-items: center;
  background-color: ${color.grey['900']};
`;

export const BackButton = styled.button`
  ${ResetButtonStyle};
  position: absolute;
  top: 50%;
  left: 16px;
  width: 32px;
  height: 32px;
  transform: translateY(-50%);
  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ActionButton = styled.button`
  ${ResetButtonStyle};
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  color: ${textColor.secondary};
  font-size: 16px;
  :disabled {
    opacity: 0.5;
  }
`;

export const MinorActionButton = styled.button`
  ${ResetButtonStyle};
  margin: 12px 0;
  padding: 0px 16px;
  color: ${textColor.secondary};
  font-size: 14px;
`;

export const Title = styled.div`
  ${TextEllipsis};
  padding: 0px 52px;
  flex: auto;
  color: ${textColor.white};
  font-size: 16px;
  text-align: center;
`;

export const Body = styled.div``;

export const Section = styled.div`
  margin-top: 16px;
`;

export const SectionTitle = styled.div`
  margin-bottom: 12px;
  padding: 0px 16px;
  font-size: 14px;
  color: ${textColor.black};
  display: flex;
  justify-content: space-between;
`;

export const SectionBody = styled.div`
  border-top: 1px solid rgba(100, 100, 100, 0.25);
  border-bottom: 1px solid rgba(100, 100, 100, 0.25);
  background-color: ${color.grey['900']};
`;

export const SectionRow = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Row = styled.div`
  margin-left: 16px;
  padding-right: 16px;
  min-height: 36px;
  display: flex;
  align-items: center;
  & + & {
    border-top: 1px solid rgba(100, 100, 100, 0.25);
  }
`;

export const TestedAt = styled.div`
  text-align: center;
  font-size: 14px;
  color: ${textColor.black};
`;

export const TestAsset = styled(TestedAt)`
  padding: 0 16px;
  font-size: 12px;
`;

export const RowTitle = styled.div`
  margin-right: 12px;
  flex: none;
  color: ${textColor.white};
  font-size: 14px;
  display: flex;
  align-items: center;
`;

export const RowContent = styled.div`
  margin-left: auto;
  font-size: 14px;
  color: ${textColor.black};
  word-break: break-all;
`;

export const AccordionRow = styled(Row)`
  height: auto;
`;

export const AccordionSectionRow = styled(SectionRow)`
  display: block;
`;

export const AccordionRowTitle = styled(RowTitle)`
  min-height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${({ selected }) =>
    selected
      ? css`
          position: sticky;
          top: -16px;
          background-color: ${color.grey['900']};
        `
      : css``}
`;

export const AccordionDropDownIcon = styled.img.attrs(
  ({ isActive, widthSize = 20, heightSize = 20 }) => ({
    style: {
      transform: isActive ? 'rotate(180deg)' : 'none',
      width: widthSize,
      height: heightSize,
    },
  })
)`
  object-fit: contain;
  transition: transform 0.3s;
`;

export const AccordionRowContent = styled(RowContent)``;
